import * as $ from 'jquery';

export class wcagOptions {
	/**
	 * add aria label to selectize created input
	 * for accessibility
	 * @param {object} el [selectize instance]
	 */
	selectizeInputAria(el:any): void {
		let labelText:any = el.$input.attr('aria-label');
		let selectizeSrcEl:any = el.$input;
		let selectizeInput:any = el.$control_input;

		// set label to selectize created autocomplete input
		// hide src select field (since not visible to ordinary users)
		selectizeInput.attr('aria-label', labelText + ' selectize input');
		selectizeSrcEl.attr({
			'aria-hidden': true,
			'aria-label': selectizeSrcEl.attr('name')
		});

		return;
	}
}
